export const createWidgetPage = () =>
  import("./CreateWidgetPage").then((m) => ({ Component: m.CreateWidgetPage }));
